import { FC } from 'react'
import cx from 'classnames'

import { SearchResultProps } from '../SearchResult'

import * as SC from './styled'

export type SearchResultsProps = MinimalSeoBlock & {
  className?: string
  title?: string
  results?: {
    title?: string
    items?: SearchResultProps[]
  }[]
}

const SearchResults: FC<SearchResultsProps> = ({
  className,
  title,
  results,
  htmlTitleTag,
}) => {
  return (
    <SC.Container className={cx('SearchResults', className)}>
      <SC.Wrapper>
        {title && <SC.Title as={htmlTitleTag}>{title}</SC.Title>}
        {results &&
          results.length > 0 &&
          results?.map((result, index) => (
            <SC.Category key={index}>
              {result.title && <SC.SubTitle>{result.title}</SC.SubTitle>}
              <SC.Results>
                {result.items?.map((item, index) => (
                  <SC._SearchResult key={index} {...item} />
                ))}
              </SC.Results>
            </SC.Category>
          ))}
      </SC.Wrapper>
    </SC.Container>
  )
}

export default SearchResults
